/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var node = document.createElement("input");                    
node.setAttribute("type","file");
if (document.getElementById("fileupload")) {
  document.getElementById("fileupload").appendChild(node); 
}

// Function to close all dropdown menus
function closeAllDropdowns() {
    document.querySelectorAll('.dropdown-menu').forEach(dropdown => {
        dropdown.style.display = 'none';
    });
}

// Event listener for each menu item
document.querySelectorAll('.menu-drawer__menu-item').forEach(item => {
    item.addEventListener('click', function(event) {
        // Close all dropdowns first
        closeAllDropdowns();

        // Prevent the event from propagating to higher-level elements
        event.stopPropagation();

        // Toggle the current dropdown
        var dropdown = this.querySelector('.dropdown-menu');
        if (dropdown) {
            dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
        }
    });
});

function closeAllDropdowns() {
    // Get all dropdowns on the page
    var allDropdowns = document.querySelectorAll('.dropdown-menu');

    // Close all dropdowns
    allDropdowns.forEach(function (dropdown) {
        dropdown.style.display = 'none';
    });
}


// // Clicking outside of menus closes any open menu
// document.addEventListener('click', function() {
//     closeAllDropdowns();
// });





